import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { MobileViewId, NavGroupId } from '@/layouts/nav';

interface UiState {
  sidebarCollapsed: Partial<Record<NavGroupId, boolean>>;
  toggleSidebarGroup: (id: NavGroupId) => void;
  mobileView: MobileViewId | null;
  setMobileView: (view: MobileViewId | null) => void;
  mobileDrawerOpen: boolean;
  setMobileDrawerOpen: (open: boolean) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set, get) => ({
      sidebarCollapsed: {},
      toggleSidebarGroup: (id) =>
        set({
          sidebarCollapsed: {
            ...get().sidebarCollapsed,
            [id]: !get().sidebarCollapsed[id],
          },
        }),
      mobileView: null,
      setMobileView: (view) => set({ mobileView: view }),
      mobileDrawerOpen: false,
      setMobileDrawerOpen: (open) => set({ mobileDrawerOpen: open }),
    }),
    {
      name: 'synapse.ui',
      partialize: (state) => ({
        sidebarCollapsed: state.sidebarCollapsed,
        mobileView: state.mobileView,
      }),
    },
  ),
);
